/**
 *  Load modules
 */
import common from './modules/common';
import swiper from './modules/swiper';
import lightbox from './modules/lightbox';
import './modules/selectize';
import CommunityMap from "./modules/community-map";
import ContactMap from "./modules/contact-map";
import '../scss/app.scss';
$(document).ready(() => {
  common();
  swiper();
  lightbox();
  new ContactMap('.js-contact-map').initMap();
  new ContactMap('.js-single-community-map').initMap();
  $('.section-intro-slider .js-community-map-btn').on('click', function (e) {
    e.preventDefault();
    var dataTerm = $(this).attr('data-term');
    var doIt = $('.js-tab-item-link[data-term=' + dataTerm + ']').attr('href');
    $('.js-tab-item-link').removeClass('active');
    $('.js-tab-item-link[data-term=' + dataTerm + ']').addClass('active');
    $('.js-tab-item').addClass('el-none');
    $(doIt).removeClass('el-none');
  });
  const vidPlop = document.getElementsByClassName('swiper-slide');
  const options = {
    attributes: true
  };
  var slideCount = 0;
  var vidPath;
  var prevPath;
  $('.swiper-slide').each(function () {
    slideCount++;
    $(this).find('video').attr('id', 'slide-' + slideCount);
  });
  function playVideo(whichVid) {
    var vid = document.getElementById(whichVid);
    vid.currentTime = 0;
    vid.play();
  }
  function stopVideo(whichVid) {
    var vid = document.getElementById(whichVid);
    vid.pause();
  }
  var didItOnce = false;
  function playVidPlop(mutationList, observer) {
    mutationList.forEach(function (mutation) {
      if (didItOnce === false && mutation.type === 'attributes' && mutation.attributeName === 'class') {
        didItOnce = true;
        // do something here
        //var vid = document.getElementById();
        if ($('.swiper-slide').hasClass('swiper-slide-active')) {
          vidPath = $('.swiper-slide-active').find('video').attr('id');
        }
        if ($('.swiper-slide').hasClass('swiper-slide-prev')) {
          prevPath = $('.swiper-slide-prev').find('video').attr('id');
        }
      }
    });
    //stopVideo(prevPath);
    playVideo(vidPath);
  }
  //const observer = new MutationObserver(playVidPlop)
  //observer.observe(vidPlop[0], options);
  //playVideo('slide-1');

  // $('.section-with-text__content--lg').css({'opacity': 0});

  // const checkpoint = 300;
  // var opacity;

  function showOnScroll() {
    /* Check the location of each desired element */
    $('section:not(:first-child)').each(function (i) {
      var bottom_of_object = $(this).position().top + $(window).height() / 5;
      var bottom_of_window = $(window).scrollTop() + $(window).height();
      /* If the object is completely visible in the window, fade it it */
      if (bottom_of_window > bottom_of_object) {
        $(this).addClass('in-view');
      } else {
        //$(this).removeClass('in-view');
      }
    });
  }
  showOnScroll();
  $(window).on('scroll', () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll > 50) {
      $('.header').addClass('sticky');
    } else {
      $('.header').removeClass('sticky');
    }
    showOnScroll();
  });
  $('.side-nav li a').on('click', function (e) {
    e.preventDefault();
    var scrollToHere = $(this).attr('href');
    var endUp = $(scrollToHere);
    $("html").animate({
      scrollTop: endUp.offset().top + "px"
    });
  });
  $('body').on('click', '.view-all', function () {
    //$('body').find('.selectize-input').children('div.item').text('Location').attr('data-value','all');
    $('.section-communities .communities-list__filter .filter-list li .selectize-dropdown .option:first-child').trigger('click');
  });
  const myInterval = setInterval(myTimer, 250);
  function myStopFunction() {
    clearInterval(myInterval);
  }
  setTimeout(myStopFunction, 6000);
  function myTimer() {
    if ($('body').hasClass('page-communities')) {
      var filterTerms = window.location.href;
      console.log("timer fired!");
      if ($('input[value=' + filterTerms.split('=')[1] + ']').length) {
        $('input[value=' + filterTerms.split('=')[1] + ']').trigger('click');
        myStopFunction();
      }
    }
  }
  $('.menu-item-has-children a').on('click', function (e) {
    e.preventDefault();
    var whereToMac = $(this).attr('href');
    window.location.assign(whereToMac);
  });
});